import { creatorbase } from '@round/api';
import { GenericDropdownOption } from 'App.types';
import capitalize from 'lodash/capitalize';

const editableStatuses: (
    | Extract<creatorbase.PostPaymentStatus, 'PAID' | 'UNPAID'>
    | Extract<creatorbase.PostPaymentRequestStatus, 'CANCELLED'>
)[] = ['PAID', 'UNPAID', 'CANCELLED'];
const selectableStatuses: Extract<creatorbase.PostPaymentStatus, 'PAID' | 'UNPAID'>[] = ['PAID', 'UNPAID'];

type Option = GenericDropdownOption<(typeof editableStatuses)[number]>;

export const OPTIONS: Option[] = editableStatuses.map((value) => ({
    value,
    label: capitalize(value.toLowerCase()),
}));

export const SELECTABLE_OPTIONS: Option[] = OPTIONS.filter((option) =>
    selectableStatuses.find((status) => status === option.value)
);
